import { Paper, Box, Typography, LinearProgress } from '@mui/material';
import { formatHours, formatMoney, formatMoneyFull } from './constants';

export function RollupCards({ rollup, loading }) {
  if (loading) {
    return (
      <Box sx={{ py: 2 }}><LinearProgress /></Box>
    );
  }
  if (!rollup) return null;
  const { hours = 0, expenses_total = 0, linked_jobs_revenue = 0, linked_jobs_count = 0, task_completion = { done: 0, total: 0 } } = rollup;
  const pct = task_completion.total > 0 ? Math.round((task_completion.done / task_completion.total) * 100) : 0;

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, gap: 1.5, mb: 2 }}>
      <Card label="Hours" primary={formatHours(hours)} secondary="subtree total" />
      <Card label="Expenses" primary={formatMoneyFull(expenses_total)} secondary="subtree total" />
      <Card label="Linked revenue" primary={formatMoneyFull(linked_jobs_revenue)} secondary={`${linked_jobs_count} job${linked_jobs_count === 1 ? '' : 's'}`} />
      <Card label="Tasks" primary={`${task_completion.done} / ${task_completion.total}`} secondary={task_completion.total ? `${pct}% done` : 'no tasks'} />
    </Box>
  );
}

function Card({ label, primary, secondary }) {
  return (
    <Paper variant="outlined" sx={{ p: 1.5 }}>
      <Typography variant="caption" sx={{ color: 'text.secondary', textTransform: 'uppercase', fontSize: '0.65rem', letterSpacing: 0.5 }}>
        {label}
      </Typography>
      <Typography variant="h6" sx={{ fontVariantNumeric: 'tabular-nums', my: 0.25 }}>{primary}</Typography>
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>{secondary}</Typography>
    </Paper>
  );
}

export function BarList({ title, rows, valueFormat = (v) => v }) {
  if (!rows || rows.length === 0) return null;
  const max = Math.max(...rows.map((r) => Number(r.value) || 0), 1);
  return (
    <Paper variant="outlined" sx={{ p: 1.5, mb: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>{title}</Typography>
      {rows.map((r, i) => {
        const v = Number(r.value) || 0;
        const pct = (v / max) * 100;
        return (
          <Box key={i} sx={{ display: 'grid', gridTemplateColumns: '140px 1fr 90px', gap: 1, alignItems: 'center', mb: 0.5 }}>
            <Typography variant="body2" noWrap>{r.label || '—'}</Typography>
            <Box sx={{ height: 8, bgcolor: 'action.hover', borderRadius: 1, overflow: 'hidden' }}>
              <Box sx={{ width: `${pct}%`, height: '100%', bgcolor: 'primary.main' }} />
            </Box>
            <Typography variant="body2" sx={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right' }}>
              {valueFormat(v)}
            </Typography>
          </Box>
        );
      })}
    </Paper>
  );
}
